// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--cfc6a";
export var outline = "button-module--outline--0c632";
export var primary = "button-module--primary--4b452";